/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {DateRangePickerDropDown} from '@insticator/insticator-ui';
// utils
import {isAfterFourPM, getDateNYC} from '@insticator/insticator-ui';
// static
import {REPORT_FROM, REPORT_RANGE, REPORT_TO} from "../../consts";





/* ========== ~~~~~~~~~~ DATE PICKER (PERIOD) FILTER ~~~~~~~~~~ ========== */

export default (props) => {
    // component props
    const { handleOnChange, uuid } = props;
    const report = useSelector((state) => state.report);
    const selectedDateRange = useSelector((state) => state.app.filters.dateRange)
    const formValues = report[uuid] ?? {};
    const latestReportDate = new Date()

    const [range, setRange] = useState({
        [REPORT_RANGE]: formValues[REPORT_RANGE],
        [REPORT_FROM]: formValues[REPORT_FROM] ? formValues[REPORT_FROM] : selectedDateRange.from,
        [REPORT_TO]: formValues[REPORT_TO] ? formValues[REPORT_TO] : selectedDateRange.to
    });


    const getDisabledDates = () => [{
        after: new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2)))
    }]

    return (
            <DateRangePickerDropDown
                klass={`filter-date`}
                indicatorTitle={'Date range'}
                hideButtons={false}
                showShortcuts={false}
                showShortcutTextInPreview={false}
                customDateRanges={false}
                use4PMLogic={true}
                range={range}
                updateRange={range => setRange(range)}
                handleApply={() => handleOnChange({
                    [REPORT_RANGE]: 'CUSTOM',
                    [REPORT_FROM]: range.from,
                    [REPORT_TO]: range.to,
                    })}
                disabledDays={getDisabledDates()}
            />
    );
};
